module.exports = __webpack_public_path__ + "img/5067b60e8c77313b752ee19b44f5fe17.svg";